<template>
  <DxPopup
    :visible="open"
    :ref="refPopup"
    title="Importar usuarios"
    :drag-enabled="true"
    :hide-on-outside-click="false"
    :show-close-button="true"
    @hidden="onHidden"
    :show-title="true"
    :width="455"
    :height="650"
    :shading="false"
    class="popup-import-users"
  >
    <DxToolbarItem
      widget="dxButton"
      toolbar="bottom"
      location="after"
      :options="importButtonOptions"
    />
    <DxToolbarItem
      widget="dxButton"
      toolbar="bottom"
      location="after"
      :options="closeButtonOptions"
    />
    <DxScrollView>
      <div style="margin-top: -15px">
        <p style="text-align: justify">
          Seleccione el archivo de texto (.CSV) que contiene los
          usuarios a importar con las siguientes columnas y orden:
        </p>
        <div>
          <b>[Grupo]</b> &#8594; Código del grupo al que pertenece el usuario.
        </div>
        <div>
          <b>[SubGrupo]</b> &#8594; Código del subgrupo al que pertenece el
          usuario.
        </div>
        <div><b>[Correo]</b> &#8594; Correo electrónico del usuario.</div>
        <div><b>[Nombres]</b> &#8594; Nombres del Usuario.</div>
        <div><b>[Apellidos]</b> &#8594; Apellidos del usuario.</div>
      </div>
      <div class="file-uploader-block">
        <DxFileUploader
          select-button-text="Seleccionar Archivo"
          labelText="o Suelte el archivo aquí"
          :multiple="false"
          :ref="refUploader"
          accept="text/csv"
          upload-mode="useForm"
          :allowed-file-extensions="['.csv']"
        />
        <span class="note">
          Extensiones permitidas:
          <span>.csv</span>
        </span>
      </div>
      <div>
        <strong>Resultado</strong>
        <DxTextArea
          :height="130"
          ref="TxAresultImport"
          :width="400"
          :max-length="null"
          :read-only="true"
        />
      </div>
      <i>{{result}}</i>
    </DxScrollView>
  </DxPopup>
</template>
<script>
/* eslint-disable */
import "devextreme/dist/css/dx.common.css";
import "../../themes/generated/theme.base.css";
import "../../themes/generated/theme.additional.css";
import { DxScrollView } from "devextreme-vue/scroll-view";
import DxTextArea from "devextreme-vue/text-area";
import DxPopup, { DxToolbarItem } from "devextreme-vue/popup";
import DxFileUploader from "devextreme-vue/file-uploader";
import notify from "devextreme/ui/notify";
const refPopup = "import-users";
const refUploader = "btn-import";
var _this = null;
var ui = require("../../plugins/busyUi").default;
import http from "../../api/http";
export default {
  name: "component-import-user",
  components: {
    DxPopup,
    DxToolbarItem,
    DxScrollView,
    DxTextArea,
    DxFileUploader,
  },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      refPopup,
      refUploader,
      importButtonOptions: {
        text: "Importar",
        onClick: (e) => {
          e.component.option("disabled", true);
          if (
            _this.instFileUploader._files[0].value.name.includes("csv") &&
            _this.instFileUploader._files[0].value.size > 0
          ) {
            ui.busyUi(true, $(_this.Popup._$element[0]));
            http
              .post("import_user", {
                doc: _this.instFileUploader._files[0].value,
              })
              .then((response) => {
                e.component.option("disabled", false);
                ui.busyUi(false, $(_this.Popup._$element[0]));
                if (response.STATUS_CODE == 1) {
                  _this.result="OK"
                  _this.instTextArena.option("value", response.DATA);
                } else {
                  _this.result="Error"
                  notify(
                    {
                      message: response.RESPONSE_DESCRIPTION,
                      width: "auto",
                      shading: false,
                      position: { at: "top center" },
                    },
                    "error",
                    1100
                  );
                }
              })
              .catch((error) => {
                console.error("Error de conexión", error);
                e.component.option("disabled", false);
                ui.busyUi(false, $(_this.Popup._$element[0]));
                notify(
                  {
                    message: "El archivo fue importado...",
                    width: "auto",
                    shading: false,
                  },
                  "success",
                  700
                );
              });
          } else {
            notify(
              {
                message:
                  "Ocurrio un problema al intendar importar el archivo...",
                width: "auto",
                shading: false,
                position: { at: "top center" },
              },
              "error",
              1100
            );
            e.component.option("disabled", false);
            return;
          }
        },
      },
      closeButtonOptions: {
        text: "Cancelar",
        onClick: () => {
          _this.Popup.option("visible", false);
        },
      },
      result:""
    };
  },

  methods: {
    onHidden() {
      _this.Popup.option("visible", false);
      _this.result=""
      _this.instTextArena.option("value", "");
      this.$store.commit("SetModalImportUsers");
    },
  },
  beforeDestroy() {
    this.$refs["import-users"].instance.option("visible", false);
    this.$refs["import-users"].instance.dispose();
  },
  mounted() {
    _this = this;
    this.Popup = this.$refs[refPopup] && this.$refs[refPopup].instance;
    this.instFileUploader =
      this.$refs[refUploader] && this.$refs[refUploader].instance;
    this.instTextArena =
      this.$refs["TxAresultImport"] && this.$refs["TxAresultImport"].instance;
  },
};
</script>
<style lang="scss" scoped>
.file-uploader-block {
  width: 400px;
  float: left;
}
.note {
  font-size: 12px;
  color: #484848;
  margin-left: 247px;
}
</style>